export default {
  title: 'Tipărire bonuri',
  sections: {
    destination: 'Bonurile se tipăresc la',
  },
  printers: {
    inner: {
      title: 'Imprimantă încorporată',
    },
    external: {
      title: 'Imprimantă externă',
      width_unset: 'Lățimea hârtiei nesetată',
      connect_hint: 'Conectați o imprimantă pentru a o utiliza',
      disconnect_confirm: 'Deconectați această imprimantă?',
      disconnect_confirm_description: 'Va trebui să o configurați din nou.',
      disconnect_confirm_ok: 'Da, deconectați',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Gata',
      title: 'Gata de tipărire',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Hârtie pe terminate',
      title: 'Hârtia aproape s-a terminat',
      description: 'Înlocuiți rola în curând. Tipărirea continuă.',
    },
    busy: {
      label: 'Ocupată',
      title: 'Imprimanta este ocupată',
      description: '{{name}} finalizează o altă sarcină.',
    },
    not_configured: {
      label: 'Neconfigurată',
      title: 'Neconfigurată',
      description: '{{name}} trebuie configurată înainte de a putea tipări.',
    },
    offline: {
      label: 'Offline',
      title: 'Nu tipărește',
      description: '{{name}} este offline. Comenzile noi nu sunt tipărite.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} nu este conectată.',
    },
    cover_open: {
      label: 'Capac deschis',
      title: 'Capacul este deschis',
      description: 'Închideți capacul imprimantei pentru a relua tipărirea.',
    },
    paper_empty: {
      label: 'Hârtie epuizată',
      title: 'Hârtie epuizată',
      description: 'Înlocuiți rola pentru a relua tipărirea.',
    },
    wrong_paper: {
      label: 'Hârtie greșită',
      title: 'Hârtie greșită',
      description: 'Rola încărcată nu corespunde lățimii de hârtie configurate.',
    },
    cutter_error: {
      label: 'Eroare cutter',
      title: 'Eroare cutter',
      description: 'Verificați cutter-ul pentru hârtie blocată, apoi reîncercați.',
    },
    overheat: {
      label: 'Prea fierbinte',
      title: 'Imprimanta este prea fierbinte',
      description: 'Lăsați {{name}} să se răcească înainte de a tipări din nou.',
    },
    error: {
      label: 'Eroare',
      title: 'Eroare imprimantă',
      description: '{{name}} a raportat o eroare și necesită atenție.',
    },
    connecting: {
      label: 'Se conectează…',
      title: 'Se conectează…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Neconectată',
      title: 'Neconectată',
      description: '{{name}} nu este conectată.',
    },
  },
  form: {
    auto_print: {
      label: 'Tipărire automată comenzi noi',
      not_ready:
        'Tipărirea automată este activă, dar imprimanta externă nu este pregătită. Comenzile nu vor fi tipărite.',
    },
    print_copies: {
      label: 'Copii per comandă',
      hint: 'Activați tipărirea automată pentru a seta copiile',
      decrease: 'Reduceți copiile',
      increase: 'Măriți copiile',
    },
  },
  toasts: {
    failed_to_save_changes: 'Modificările nu au putut fi salvate',
  },
  buttons: {
    test_print: 'Tipărire test',
    configure_external: 'Configurare',
    connect_external: 'Conectați o imprimantă',
    disconnect_external: 'Deconectați',
    retry_connection: 'Reîncercați conexiunea',
    cancel: 'Anulare',
  },
};
